import React, { memo, useMemo } from 'react';
import { Text } from '@Sage/hoi-poi-ui';

import LineClamp from 'components/LineClamp';

import './styles.scss';

const CommentRow = memo(({ text, subject, icon }) => {
    const classNames = useMemo(() => {
        let className = ['comment-row'];
        return className;
    }, []);

    if (!text) return null;

    return (
        <div className={classNames.join(' ')}>
            {subject && (
                <div className="comment-row__header">
                    <Text>{subject}</Text>
                    {icon}
                </div>
            )}
            <div className="comment-row__text">
                <LineClamp lines={2}>{text}</LineClamp>
            </div>
        </div>
    );
});

export default CommentRow;
